import { render, staticRenderFns } from "./TabSkeleton.vue?vue&type=template&id=be04aaac&scoped=true&"
import script from "./TabSkeleton.vue?vue&type=script&lang=js&"
export * from "./TabSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./TabSkeleton.vue?vue&type=style&index=0&id=be04aaac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be04aaac",
  null
  
)

export default component.exports